export default () => {
    return {
        generalPractitioners: {},
        practices: [],
        states: {},
        diseases: {},
        indigenousOptions: {},
        genders: {},
        urgencies: {},
        requestStatuses: {},
        disciplines: {},
        teams: {},
        costCentres: {},
        roles: {},
        serviceTaskStatuses: {},
        fieldTypes: {},
        taskTypes: {},
        taskTypeFields: {},
        taskTypeFieldOptions: {},
        isSidebarToggled: false,
        approvalCriteria: {}
    }
}
